import React from "react";

interface IRouteAbsHeader {
    routeAbstractHeader: Record<string, React.ReactNode>;
}

 export const PrepareIndentRouteWiseHeader = (props: IRouteAbsHeader) => {
  const { routeAbstractHeader } = props;
  return (
    <tr style={{ border: "1px solid #E5E4E2", backgroundColor: "#E5E4E2", borderRadius: "5px" }}>
      {Object.entries(routeAbstractHeader).slice(1).map(([key, headerName], index, array) => (
        <th 
          key={key} 
          style={index === array.length - 1 ? { float: "right" } : {}}
          className={index === 0  ? "text-start" : "text-end"}
        >
          {index === 0 ? "CATEGORY" : headerName}
        </th>
        
      ))}
    </tr>
  );
};
